/* eslint-disable */

import $ from 'jquery';

import loadingLayer from '../../util/loadingLayer';
import formMessages from '../../util/formMessages';

export default {
    init() {
        formMessages().useCaptcha();
        const $form = $('#login-form');
        formMessages($form).validate();

        $form.on('submit', function (event) {
            event.stopImmediatePropagation();
            event.preventDefault();

            loadingLayer.showLoading();
            formMessages($form).init();

            const url = $form.attr('action-ajax') || $form.attr('action');
            const method = $form.attr('method');

            const formData = $form.serializeArray();
            const data = {};

            for (var i in formData) {
                data[formData[i].name] = formData[i].value;

                $('#' + formData[i].name, $form).removeClass('is-invalid');
                $('#' + formData[i].name + ' ~ .invalid-feedback', $form).text('');
            }

            $.ajax({
                url,
                method,
                data: {
                    ...data,
                    nonce: window.meta_object.nonce,
                    captcha_token: window.meta_object.captcha_token,
                    action: 'member-login',
                },
                dataType: 'json',
                complete: function() {
                    formMessages().reloadCaptcha();
                },
                success: function (data) {
                    if (!data) {
                        loadingLayer.hideLoading();
                        return;
                    }

                    if (data.success) {
                        window.location.replace(window.meta_object.account_url);
                        return;
                    }

                    loadingLayer.hideLoading();
                    formMessages($form, data).run();
                },
                error: function (err) {
                    loadingLayer.hideLoading();
                }
            });
        });

        $('.hide-after-3s').each(function() {
            const $this = $(this);

            setTimeout(function() {
                $this.fadeOut(1000, 'linear', function() {
                    $this.addClass('d-none').css('display', '');
                });
            }, 3000);
        });
    },
    finalize() {

    },
};



// WEBPACK FOOTER //
// ./scripts/routes/blocks/memberLogin.js